import { X } from "lucide-react";
import { useState, useEffect } from "react";
import { isNoldDomain, isBentskinDomain } from "../lib/domain";

// Bandeau discret pour les utilisateurs multi-domaine.
// Affiché sur les dashboards livreur/resto pour rappeler la marque courante
// et permettre un accès rapide à l'autre app. L'utilisateur peut le fermer
// pour la session (persistance sessionStorage).
export default function DomainSwitcher() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem("nold_domain_switcher_dismissed") === "1"; } catch { return false; }
  });
  const [otherHost, setOtherHost] = useState("");
  const [current, setCurrent] = useState("");
  const [color, setColor] = useState("bg-[#059669]");

  useEffect(() => {
    if (isNoldDomain()) {
      setCurrent("Nold Go");
      setOtherHost("https://www.bentskingo.com");
      setColor("bg-[#059669]");
    } else if (isBentskinDomain()) {
      setCurrent("BentSkin Go");
      setOtherHost("https://www.noldgo.com");
      setColor("bg-[#F26419]");
    }
  }, []);

  const dismiss = () => {
    try { sessionStorage.setItem("nold_domain_switcher_dismissed", "1"); } catch {}
    setDismissed(true);
  };

  // N'affiche que sur un domaine prod (pas preview localhost)
  if (dismissed || !otherHost) return null;

  return (
    <div
      data-testid="domain-switcher-banner"
      className={`${color} text-white text-xs sm:text-sm px-3 py-2 flex items-center justify-center gap-3 shadow-sm`}
    >
      <span className="font-bold">📍 Vous êtes sur <b>{current}</b></span>
      <a
        href={otherHost}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="domain-switcher-link"
        className="underline underline-offset-2 hover:no-underline font-semibold whitespace-nowrap"
      >
        Aller sur l'autre app →
      </a>
      <button
        onClick={dismiss}
        data-testid="domain-switcher-close"
        aria-label="Fermer"
        className="ml-1 opacity-70 hover:opacity-100"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
